define("static/js/ziliaoNews",function(t,i){var n={init:function(){t(["static/js/alert"],function(t){t.alertObj.init()})}};i.contentObj=n});